import * as React from "react";
import {
  List, Datagrid, TextField, FunctionField, Show, SimpleShowLayout,
  useRecordContext, useRedirect, useRefresh,
} from "react-admin";
import { Box } from "@mui/material";
import { JsonField } from "../../components/JsonField";
import { ConfirmActionButton } from "../../components/ConfirmActionButton";
import { InfoGrid } from "../../components/InfoGrid";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";
import { TechInfo } from "../../components/ui";

// ReportedUserDTO : id, reporterId, reporterName, reportedUserId,
// reportedUserName, reason, timestamp (Long ms).
// Pas de champ status — l'action "résoudre" = supprimer le signalement.

const Dismiss = () => {
  const r = useRecordContext();
  const redirect = useRedirect();
  const refresh = useRefresh();
  if (!r) return null;
  return (
    <ConfirmActionButton label="Marquer comme résolu (supprimer)" color="success"
      confirmTitle="Supprimer ce signalement"
      confirmText="Le signalement sera retiré de la liste. Cette action est irréversible."
      successMessage="Signalement résolu"
      onConfirm={async () => {
        await httpClient(`${API_BASE_URL}/reports/${r.id}`, { method: "DELETE" });
        refresh();
        redirect("list", "reportedUsers");
      }}
    />
  );
};

const BanReported = () => {
  const r = useRecordContext();
  if (!r?.reportedUserId) return null;
  return (
    <ConfirmActionButton label="Suspendre l'utilisateur signalé" color="error"
      confirmTitle="Suspendre"
      confirmText={`Le compte ${r.reportedUserName || r.reportedUserId} sera désactivé.`}
      successMessage="Compte suspendu"
      onConfirm={() => httpClient(`${API_BASE_URL}/users/status/${r.reportedUserId}/false`, { method: "PUT" })}
    />
  );
};

const linkUser = (id, name) => id ? (
  <a href={`#/users/${id}/show`} style={{ color: "#0d7377", fontWeight: 600 }}>
    {name || id}
  </a>
) : "—";

const fmtTs = (ms) => ms ? new Date(Number(ms)).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—";

export default {
  list: () => (
    <List perPage={50} pagination={false} title="Signalements">
      <Datagrid rowClick="show">
        <FunctionField label="Utilisateur signalé" render={(r) => linkUser(r?.reportedUserId, r?.reportedUserName)} />
        <FunctionField label="Signalé par" render={(r) => linkUser(r?.reporterId, r?.reporterName)} />
        <TextField source="reason" label="Motif" />
        <FunctionField label="Date" render={(r) => fmtTs(r?.timestamp)} />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <InfoGrid
          fields={[
            { label: "ID", source: "id", type: "mono" },
            { label: "Utilisateur signalé", source: (r) => r?.reportedUserName || r?.reportedUserId },
            { label: "ID utilisateur signalé", source: "reportedUserId", type: "mono" },
            { label: "Signalé par", source: (r) => r?.reporterName || r?.reporterId },
            { label: "ID signaleur", source: "reporterId", type: "mono" },
            { label: "Motif", source: "reason" },
            { label: "Date", source: (r) => fmtTs(r?.timestamp) },
          ]}
        />
        <Box sx={{ display: "flex", gap: 1, mt: 2, flexWrap: "wrap" }}>
          <Dismiss />
          <BanReported />
        </Box>
        <JsonField source="__all__" />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};
